import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import Global from '@/scripts/Global'
import ChannelApi from '@/scripts/api/channel.api'
import MainNotification from '@/Manager/Notification/main.manager';
import ChannelNotification from '@/Manager/Notification/Channel.manager';
import {
    CPUtils
} from '@/scripts/Utils';
import {
    Channel
} from '@/classes/Channel';
import UserDetails from '@/components/RightSidebar/UserDetails/UserDetails.vue'
import {
    Logging
} from '@/scripts/Logging';
import config from '@/scripts/config';
import VueSignals from '@/scripts/VueSignals';
import UserApi from '@/scripts/api/user.api';

import DragAndDropMention from '@/scripts/mixins/DragAndDropMention.js';

export default {
    name: 'ChannelUsers',
    data() {
        return {
            activeChannelDoc: SessionManager.getActiveChannel(),
            // activeChannelUsers: new Set(SessionManager.getActiveChannelUsers()),
            activeChannelUsers: SessionManager.getActiveChannelUsers(),
            channelUserHighlight: false,
            loggedInUserId: SessionManager.getLoggedInUserId(),
            loggedInUser: SessionManager.getLoggedInUser(),
            showOptions: false,
            theme: 'Users',
            rightSidebarTheme: '',
            isAdmin: this.$parent.user_rights,
            userDetailsDoc: null,
            showMessage: false,
            defaultUserImage: config.DEFAULT_USER_IMAGE,
            subfolder: false,
        }
    },
    components: {
        UserDetails,
    },
    mixins: [DragAndDropMention],
    created() {
        serverBus.$on(VueSignals.ACTIVE_CHANNEL_PARENT_DOCS, (parent_docs) => {
            if (parent_docs.length > 0) {
                this.subfolder = true
            }
        })
    },
    mounted() {
        serverBus.$on(VueSignals.CHANNEL_USERS_CHANGED, (user_id) => {
            this.activeChannelUsers = SessionManager.getActiveChannelUsers()
        })

        serverBus.$on(VueSignals.CHANNEL_USERS_ACCEPTED_INVITATION, (user_id) => {
            this.activeChannelUsers.forEach((user) => {
                if (user.user_id == user_id) {
                    delete user.invitation_id;
                }
            });
        });

        serverBus.$on(VueSignals.EVENT_USER_CHANGED, (user_id) => {
            for (let i = 0; i < this.activeChannelUsers.length; i++) {
                if (this.activeChannelUsers[i].user_id == user_id) {
                    this.activeChannelUsers.splice(i, 1)
                    // this.activeChannelUsers.add(this.getUserDetails(user_id))
                    this.activeChannelUsers.push(this.getUserDetails(user_id))

                    break
                }
            }
        })

        serverBus.$on(VueSignals.LOGGED_IN_USER, (success) => {
            this.loggedInUserId = SessionManager.getLoggedInUserId()
            this.loggedInUser = SessionManager.getLoggedInUser()
        })

        serverBus.$on(VueSignals.SHOW_USER_DETAILS, (user_id) => {
            if (user_id == SessionManager.getLoggedInUserId()) {
                this.userDetailsDoc = SessionManager.getLoggedInUser()
                return
            }
            for (let i = 0; i < this.activeChannelUsers.length; i++) {
                if (this.activeChannelUsers[i].user_id == user_id) {
                    this.userDetailsDoc = this.activeChannelUsers[i]
                    break
                }
            }
        })

        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.rightSidebarTheme = theme
        })

        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (ch_id) => {
            // this.activeChannelUsers = new Set()
            this.activeChannelUsers = []
            this.activeChannelDoc.type = "folder"
        })




        serverBus.$on(VueSignals.SOCKET_USER_LEFT_CHANNEL, (res) => {
            if (this.activeChannelDoc.channel_id === res.channel_id) {
                for (let i = 0; i < this.activeChannelUsers.length; i++) {
                    if (this.activeChannelUsers[i].user_id == res.origin.user_id) {
                        this.activeChannelUsers.splice(i, 1);
                        break
                    }
                }
            }
        })




        serverBus.$on(VueSignals.SOCKET_REMOVE_USER_FROM_CHANNEL, (data) => {
            if (data.event == VueSignals.SOCKET_REMOVE_USER_FROM_CHANNEL) {
                if (typeof data.removed_user_id != 'undefined')
                    SessionManager.RemoveUserFromChannel(data.channel_id, data.removed_user_id)
            }
        })



        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (success) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()
            // this.activeChannelUsers = new Set()
            this.activeChannelUsers = []
            if (this.activeChannelDoc.type != 'invitation' &&
                this.activeChannelDoc.user_ids != 'undefined') {
                this.userDetailsDoc = null
                // this.activeChannelUsers = new Set(SessionManager.getActiveChannelUsers())
                this.activeChannelUsers = SessionManager.getActiveChannelUsers()
            } else {
                // this.activeChannelUsers = new Set()
                this.activeChannelUsers = []
            }
        })

        serverBus.$on(VueSignals.CHANNEL_DETAILS_OVERRIDED, (ch_id) => {
            /**get Pending users to array */
            let invitations = SessionManager.getActiveChannel().invitations
            this.isAdmin = SessionManager.getActiveChannel().admin
            // this.activeChannelUsers = new Set(SessionManager.getActiveChannelUsers())
            this.activeChannelUsers = SessionManager.getActiveChannelUsers()
            /*Filter the suggestion from invitation users*/


            if (typeof invitations != 'undefined') {

                for (let i = 0; i < invitations.length; i++) {
                    let inviteeUser = SessionManager.getUserByEmail(invitations[i].email)
                    if (inviteeUser.email.trim().length > 0) {
                        inviteeUser.invitation_id = invitations[i].invitation_id
                        this.activeChannelUsers.push(inviteeUser)
                    } else {
                        this.activeChannelUsers.push({
                            'invitation_id': invitations[i].invitation_id,
                            'email': invitations[i].email
                        })
                    }
                }
            }

            //@TODO graylog check
        })

        /**
         * Remove pending invitations from all views
         */
        serverBus.$on(VueSignals.SOCKET_CHANNEL_REMOVE_INVITATION, (channel_remove_invite) => {
            if (typeof channel_remove_invite.invitation_id != 'undefined') {
                for (let i = 0; i < this.activeChannelUsers.length; i++) {
                    if (this.activeChannelUsers[i].invitation_id == channel_remove_invite.invitation_id) {
                        this.activeChannelUsers.splice(i, 1)
                        break
                    }
                }
            }
        })




        setTimeout(function() {
            /****************** Notification Permission  **********************/
            if (MainNotification.getStatus() != 'granted') {
                Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, true)
            }
        }, 2000)




        serverBus.$on(VueSignals.CHANNEL_USERS_HIGHLIGHT, (channel_user_highlight) => {
            this.channelUserHighlight = true
            setTimeout(function() {
                Global.globalValue(VueSignals.REMOVE_CHANNEL_OPTIONS_HIGHLIGHT, false);
            }, 2000)
        })

        serverBus.$on(VueSignals.REMOVE_CHANNEL_OPTIONS_HIGHLIGHT, (success) => {
            this.channelUserHighlight = false
        })

        serverBus.$on(VueSignals.SHOW_MENTION_DETAILS, (data) => {
            if (data.type == "user") {
                Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_users')
                this.UserDetails(SessionManager.getUsers().find(currElem => {
                    return currElem.user_id == data.data_id
                }))
            }
        })


        if (this.activeChannelUsers.length == 0) {
            // this.activeChannelUsers = new Set(SessionManager.getActiveChannelUsers())
            this.activeChannelUsers = SessionManager.getActiveChannelUsers()
        }

    },
    methods: {
        InviteUser() {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'invite_user')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
            Global.globalValue(VueSignals.OVERLAY_DATA, {
                "subfolder": this.subfolder
            })
        },
        getUserDetails(user_id) {
            return SessionManager.getUser(user_id);
        },
        deleteInvite(invite_id, removed_user_id) {
            if (invite_id != null) {
                let data = {
                    "invite_id": invite_id
                }
                ChannelApi.deleteInviteUser(data).then(res => {
                    if (res.data.result) {
                        let user_ids = this.activeChannelDoc.user_ids
                        user_ids.push(removed_user_id)
                        ChannelNotification.RemoveChannelInvite(invite_id, user_ids, this.activeChannelDoc.channel_id, removed_user_id)
                    } else {
                        Logging.Debug(res)
                    }
                })
            }

        },
        DirectMessage(user_id, channel_id) {
            if (user_id != SessionManager.getLoggedInUser().user_id) {
                if (typeof channel_id != 'undefined' && channel_id != 'direct_message') {
                    SessionManager.setActiveChannelById(channel_id)
                } else {
                    ChannelApi.createDirect(user_id).then(res => {
                        if (res.data.result) {
                            let channel = new Channel(res.data.channel)
                            channel.channel_name = SessionManager.getUser(user_id).username
                            SessionManager.setActiveChannel(channel)
                        } else {
                            if (res.data.reason == "channel_already_exists") {
                                let channel = SessionManager.getChannel(res.data.channel_id)
                                channel.channel_name = SessionManager.getUser(user_id).username
                                SessionManager.setActiveChannel(channel)
                            }
                        }
                        Global.globalValue(VueSignals.ACTIVATED_VIEW, "Chat")
                    })
                }
            }
        },
        UserDetails(user) {
            this.userDetailsDoc = user
        },
        DeleteUser(user) {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'delete_user')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "user": user
            })
        },

        isDraggable(user) {
            // Only mention users when not direct chat
            if (this.activeChannelDoc.direct) {
                return false;
            }
            // Can't mention yourself
            if (user.user_id === this.loggedInUserId) {
                return false;
            }
            return !this.activeChannelDoc.direct;
        },

    }
}
